// API configuration
// Uses VITE_API_URL from environment variables
// Falls back to relative paths for development with Vite proxy

const API_URL = import.meta.env.VITE_API_URL || ''

export const API_BASE = `${API_URL}/v1`
export const AUTH_URL = `${API_URL}/v1/auth`
export const ADMIN_URL = `${API_URL}/v1/admin`

export default API_URL
